import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import { login, guestLogin, guestLoginDemo, getUserPermissions,getTenantSettings} from '../features/Auth/store/authThunks'
import { getSubDomain } from '../features/Auth/utils/AuthUtils' 

export const listenerMiddleware = createListenerMiddleware();
export const notificationMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  matcher: isAnyOf(login.fulfilled, guestLogin.fulfilled, guestLoginDemo.fulfilled),
  effect: async (_action, api) => {
    try {
      const state = api.getState();
      const token = state.auth.token;
      if (!token) {
        console.warn("[Listener] Pas de token dispo après login → skip getUserPermissions");
        return;
      }
      await api.dispatch(getUserPermissions()).unwrap();

      const subDomain = getSubDomain(); 
      if (subDomain) {
      await api.dispatch(getTenantSettings({params: [{subDomain}]})).unwrap();
    }
    } catch (e) {
      console.warn('Post-login listeners failed:', e);
    }
  },
});

export const apiMiddleware = (store) => (next) => (action) => {
  // Handle API actions
  if (action.type?.endsWith('/pending')) {
    // Handle loading states
    //console.log('API request started:', action.type)
  }

  if (action.type?.endsWith('/fulfilled')) {
    // Handle success states
    //console.log('API request succeeded:', action.type)
  }

  if (action.type?.endsWith('/rejected')) {
    // Handle error states
    const error = action.payload || action.error;
    console.log('API request failed:', action.type, error)
  }

  return next(action)
}

// Error handling middleware
export const errorMiddleware = (store) => (next) => (action) => {
  try {
    return next(action)
  } catch (error) {
    console.error('Redux error:', error)
    // You could dispatch an error action here
    // store.dispatch(setGlobalError(error.message))
    throw error
  }
}
